var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 12.4997V15.833M15.833 14.1663H12.4997M13.6663 8.33301H14.6663C15.7709 8.33301 16.6663 7.43758 16.6663 6.33301V5.33301C16.6663 4.22844 15.7709 3.33301 14.6663 3.33301H13.6663C12.5618 3.33301 11.6663 4.22844 11.6663 5.33301V6.33301C11.6663 7.43758 12.5618 8.33301 13.6663 8.33301ZM5.33301 16.6663H6.33301C7.43758 16.6663 8.33301 15.7709 8.33301 14.6663V13.6663C8.33301 12.5618 7.43758 11.6663 6.33301 11.6663H5.33301C4.22844 11.6663 3.33301 12.5618 3.33301 13.6663V14.6663C3.33301 15.7709 4.22844 16.6663 5.33301 16.6663ZM5.33301 8.33301H6.33301C7.43758 8.33301 8.33301 7.43758 8.33301 6.33301V5.33301C8.33301 4.22844 7.43758 3.33301 6.33301 3.33301H5.33301C4.22844 3.33301 3.33301 4.22844 3.33301 5.33301V6.33301C3.33301 7.43758 4.22844 8.33301 5.33301 8.33301Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHover);
export default __webpack_public_path__ + "static/media/dashboardHover.ccdca75406f0230a45cf76070e9564e1.svg";
export { ForwardRef as ReactComponent };